import { useQuery } from '@tanstack/react-query';

import { postData } from 'src/app/queries';
import { useNotificationActions } from 'src/app/state/notifications';

import { smartTagKeys } from './query-key-factory';

import type { Schema, RuleGroup } from 'src/app/components/lib/query-builder/use-query-builder';

type useGetTagDetailsPayload = {
  Id: number | null;
};

type useGetTagDetailsQueryParams = {
  enabled?: boolean;
  tagId: number | null;
};

const GET_TAG_DETAILS = 'api/smart-tags/get-smart-tag-details';

export type SmartTagDetailsResponse = {
  details: RuleGroup;
  isInactive: boolean;
  name?: string;
  schema: Schema;
};

export function useGetTagDetailsQuery({ tagId, enabled = true }: useGetTagDetailsQueryParams) {
  const notifications = useNotificationActions();
  return useQuery({
    queryKey: smartTagKeys.one(tagId),
    queryFn: () =>
      postData<useGetTagDetailsPayload, SmartTagDetailsResponse>({
        endpoint: GET_TAG_DETAILS,
        payload: { Id: tagId },
      }),
    enabled,
    onError: () => {
      notifications.error({ message: 'Error fetching tag details' });
    },
    refetchOnWindowFocus: false,
  });
}
